import { Form, InputLabel, Space, Text } from '@procurify/ui'

import { PriceFormField } from '@webapp/components/PriceField'
import { CurrencySelect } from '@webapp/core/components/CurrencySelect'
import { Price } from '@webapp/core/components/Price'
import {
  type Currency,
  type CurrencyName,
} from '@webapp/core/entities/external/Currency'
import { useProcurifyIntl } from '@webapp/hooks'
import { TaxFields } from './TaxFields'
import messages from '../messages'

interface LabourFieldsProps {
  currencyName: CurrencyName
  selectedCurrency: Currency | null
  onCurrencyChange: (currency: Currency | null) => void
  computedSubtotal: number
  computedTotal: number
  isSubmitting: boolean
  canOverrideTaxAmount: boolean
}

export const LabourFields = ({
  currencyName,
  selectedCurrency,
  onCurrencyChange,
  computedSubtotal,
  computedTotal,
  isSubmitting,
  canOverrideTaxAmount,
}: LabourFieldsProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space>
      <Space align='center' justify='end' direction='horizontal'>
        <Space.Item>
          <InputLabel htmlFor='hourlyRate'>
            {intl.formatMessage(messages.hourlyRateLabel)}
          </InputLabel>
        </Space.Item>
        <Space.Item width={1 / 3}>
          <PriceFormField
            id='hourlyRate'
            name='hourlyRate'
            disabled={isSubmitting}
            inputProps={{ style: { textAlign: 'right' } }}
          />
        </Space.Item>
        <Space.Item width={1 / 3}>
          <CurrencySelect
            inputId='labourFields-currency-select'
            value={selectedCurrency}
            onChange={onCurrencyChange}
            isDisabled={isSubmitting}
            menuPortalTarget={document.body}
          />
        </Space.Item>
      </Space>

      <Space align='center' justify='end' direction='horizontal'>
        <Space.Item>
          <InputLabel htmlFor='hoursOfWork'>
            {intl.formatMessage(messages.hoursOfWorkLabel)}
          </InputLabel>
        </Space.Item>
        <Space.Item width={1 / 3}>
          <Form.NumberField
            id='hoursOfWork'
            name='hoursOfWork'
            disabled={isSubmitting}
            inputProps={{ style: { textAlign: 'right' } }}
          />
        </Space.Item>
        <Space.Item width={1 / 3}>
          <InputLabel>{intl.formatMessage(messages.hoursLabel)}</InputLabel>
        </Space.Item>
      </Space>

      <Space align='center' justify='end' direction='horizontal'>
        <Space.Item>
          <Text bold>{intl.formatMessage(messages.subtotalLabel)}</Text>
        </Space.Item>
        <Space.Item>
          <Price price={computedSubtotal} currency={currencyName} />
        </Space.Item>
      </Space>

      <TaxFields
        isSubmitting={isSubmitting}
        canOverrideTaxAmount={canOverrideTaxAmount}
      />

      <Space align='center' justify='end' direction='horizontal'>
        <Text bold>{intl.formatMessage(messages.totalLabel)}</Text>
        <Price price={computedTotal} currency={currencyName} />
      </Space>
    </Space>
  )
}
